import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import {
  getSkillAction,
  updateSkillAction,
  getSkillAuthorsAction,
  deleteSkillAction,
  toExpertizeAction,
  publishAction,
  changeSkill
} from "../../store/actions";
import SkillInfoDrawer from "../../../../Dict/Skills/Skill/components/SkillInfoDrawer";
import SquareButton from "../../../../ui/SquareButton";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Tabs from "../../../../ui/Tabs";
import Box from "../../../../ui/Box";
import Progress from "../../../../ui/Progress";
import Button from "../../../../ui/Button";
import ActionsMenu from "../../../../ui/ActionsMenu";
import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";

import TopBar from './components/TopBar';
import SkillEditDesc from './components/SkillEditDesc';
import SkillEditQualification from './components/SkillEditQualification';
import SkillEditPassport from './components/SkillEditPassport';
import SkillEditWorkplace from './components/SkillEditWorkplace';
import SkillEditStaff from './components/SkillViewStaff';
import SkillEditGrading from './components/SkillEditGrading';
import SkillEditInfrastructure from './components/SkillEditInfrastructure';

import {useMediaQuery} from 'react-responsive';

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Конструктор компетенций",
    link: "/work/app/constructor/competences"
  }
];

const tabitems = [
  {number: 0, caption: "Паспорт"},
  {number: 1, caption: "Описание"},
  {number: 2, caption: "Квалификационные требования"},
  {number: 3, caption: "Инфраструктурный лист"},
  {number: 4, caption: "Требования к организации рабочего места и технике безопасности"},
  {number: 5, caption: "Требования к квалификации педагогического состава"},
  {number: 6, caption: "Оценивание"}
];

const useStyles = makeStyles({
  skillRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  },
  colorDevelopment: {
    backgroundColor: "rgba(119, 136, 153, 0.7)"
  },
  colorExpertize: {
    backgroundColor: "rgba(0, 127, 189, 0.7)"
  },
  colorApproved: {
    backgroundColor: "rgba(255, 149, 0, 0.7)"
  },
  colorPublished: {
    backgroundColor: "rgba(133, 196, 70, 0.8)"
  }
});

const CompetenceEdit = props => {
  const skillId = props.match.params.id;
  const {
    skill,
    me,
    getSkill,
    updateSkill,
    getAuthors,
    deleteSkill,
    sendToExpertize,
    publish
  } = props;
  const classes = useStyles();
  const [isEdited, setIsEdited] = useState(false);
  const [deleteConfimationOpen, setDeleteConfimationOpen] = useState(false);

  const [skillData, setSkillData_] = React.useState(skill.data);

  const setSkillData = newData => {
    const newSkillData = {
      ...skillData,
      ...newData
    };

    setSkillData_(newSkillData);
    setIsEdited(true);
  };

  const isMedium = useMediaQuery({maxWidth: 1024});
  const isLarge = useMediaQuery({minWidth: 1024});
  const isSmall = useMediaQuery({maxWidth: 774});

  useEffect(() => {
    getSkill(skillId);
    getAuthors(skillId);
    setIsEdited(false);
  }, []);

  const goBack = () => {
    props.history.goBack();
  };

  const handleSave = () => {
    if (skillData.data && skillData.data.main) {
      /*let data = {
        ...skillData.data.main,
        orgId: (me && me.orgId) ? me.orgId : 72023
      };*/
      updateSkill(skillId, skillData.data.main);
    }

  };

  const handleToExpertize = () => {
    sendToExpertize(skillId);
  };

  const handleToPublish = () => {
    publish(skillId);
  };

  const toogleDeleteModal = (show) => {
    setDeleteConfimationOpen(show);
  };

  const removeSkill = () => {
    deleteSkill([skillId]);
  };

  const handleCloneSkill = () => {};

  return (
    <div>
      <Breadcrumbs items={items} />
      {(skill && skill.info && skill.data) ? (
      <div className={classes.skillRoot}>
        <DeleteConfirmationModal
          open={deleteConfimationOpen}
          onConfirm={removeSkill}
          handleClose={()=> toogleDeleteModal(false)}
        />
        <div className={classes.pageRoot}>
          <div className={classes.topBar}>
            <TopBar
              reload={() => getSkill(skillId)}
              returnBack={goBack}
              update={handleSave}
              cloneSkill={handleCloneSkill}
              openDeleteModal={()=> toogleDeleteModal(true)}
              handleToPublish={handleToPublish}
              handleToExpertize={handleToExpertize}
              statusId={skill.info.statusId}
              disabled={!isEdited}
            />
          </div>

          <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
            <Box noMargin>
              <SkillEditPassport skillData={skill.data} skillInfo={skill.info}
              onFormChange={main =>
                  setSkillData({
                      data: {
                          ...skillData,
                          main
                      }
                  })
              }/>
            </Box>
            <Box noMargin>
              <SkillEditDesc desc={skill.data ? skill.data.description : ''}
              onFormChange={desc =>
                  setSkillData({
                      data: {
                          ...skillData,
                          desc
                      }
                  })
              }/>
            </Box>
            <Box noMargin>
              <SkillEditQualification id={skill.info.id} />
            </Box>
            <Box noMargin>
              {skill.info && <SkillEditInfrastructure id={skill.info.id} />}
            </Box>
            <Box noMargin>
              <SkillEditWorkplace safety={skill.data ? skill.data.safety : ''}
                                safetyFirst={skill.data ? skill.data.safetyFirst : ''}
                                onFormChange={data =>
                                    setSkillData({
                                        data: {
                                            ...skillData,
                                            data
                                        }
                                    })
                                }/>

            </Box>
            <Box noMargin>
                <SkillEditStaff
                    teacherLevel={skill.data ? skill.data.teacherLevel : ''}
                    teacherStage={skill.data ? skill.data.teacherStage : ''}
                    teacherProf={skill.data ? skill.data.teacherProf : ''}
                    teacherExtra={skill.data ? skill.data.teacherExtra : ''}
                    onFormChange={data =>
                        setSkillData({
                            data: {
                                ...skillData,
                                data
                            }
                        })
                    }
                />
            </Box>
            <Box noMargin>
              {skill.data && <SkillEditGrading id={skill.info.id} />}
            </Box>
          </Tabs>
        </div>
        {isLarge &&
        <SkillInfoDrawer skillId={skillId} open={true} hideLink />}
        </div>
      ) : (
        <Progress/>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  skill: state.skillConstruct.skill,
  authors: state.skillConstruct.skillAuthors,
  me: state.me.me
});

const mapDispatchToProps = dispatch => ({
  getSkill: skillId => dispatch(getSkillAction(skillId)),
  updateSkill: (skillId, skill) => dispatch(updateSkillAction(skillId, skill)),
  deleteSkill: idList => dispatch(deleteSkillAction(idList)),
  getAuthors: skillId => dispatch(getSkillAuthorsAction(skillId)),
  sendToExpertize: skillId => dispatch(toExpertizeAction(skillId)),
  publish: skillId => dispatch(publishAction(skillId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CompetenceEdit));
